import { computed } from "vue";
import { openMenu } from "./ContextMenu";
import { clearMeasuring, isMeasuring, measuringLocations, startMeasuring, startTargetMeasuring, stopMeasuring } from "./DistanceMeasuring";
import { addCustomMarker } from "./MapSetting";
import { showDeviceSimple } from "./ModalUtility";
import { state } from "./SearchDevice";
import { setDefaultLatLng } from "./Setting";

//#region 임시작업
const loginId = computed(() => {
  const session = localStorage.getItem("session");
  if (session) {
    const parsedSession = JSON.parse(session);
    return parsedSession.loginid || "Guest";
  } else {
    return "Guest";
  }
});
//#endregion

//#region 클릭(좌/우) 메뉴 관련
//#region 메뉴 항목 관련
export const menuItems = {
  measuring: {
    label: measuringLocations.value.length > 0 ? '측위 초기화' : '측위 시작',
    action: () =>
      isMeasuring.value
        ? stopMeasuring(state.map)
        : measuringLocations.value.length !== 0
        ? clearMeasuring(state.map)
        : startMeasuring(isMeasuring.value),
  },
};
//#endregion

//#region 지도 우클릭 메뉴
export const handleMapContextMenu = (event) => {
  const menu = [
    {
      label: measuringLocations.value.length > 0 ? '측위 초기화' : '측위 시작',
      action: () => measuringLocations.value.length > 0 ? clearMeasuring(state.map) : startMeasuring(isMeasuring.value),
    },
    {
      label: '고정 위치 설정',
      action: () => setDefaultLatLng(event),
    },
    loginId.value !== 'user' ?
    {
      label: 'POI 추가',
      action: () => addCustomMarker(event),
    } : null,
  ];
  openMenu(event.originalEvent, menu);
};
//#endregion

//#region 단일 마커 우클릭 시 메뉴 구성
export const handleMarkerContextMenu = (event, item) => {
  const menu = [
    {
      label: measuringLocations.value.length > 0 ? '지정 측위 초기화' : '지정 측위 시작 (' + (item.device_name) + ')',
      action: () => measuringLocations.value.length > 0 ? clearMeasuring(state.map) : startTargetMeasuring(item),
    },
  ];
  openMenu(event, menu);
};
//#endregion

//#region 중첩된 마커 좌클릭 시 메뉴 구성
export const handleMarkersClickMenu = (event, group) => {
  const menu = group.devices.map((item) => ({
    label: `${item.item.device_name}`,
    action: () => showDeviceSimple(item.item),
  }));
  openMenu(event, menu);
};
//#endregion

//#region 중첩된 마커 우클릭 시 메뉴 구성
export const handleMarkersContextMenu = (event, group) => {
  // 측위 관련 메뉴
  const measuringSub = group.devices.map((item) => ({
    label: `${item.item.device_name}`,
    action: () => startTargetMeasuring(item.item),
  }));
  const menu = [
    {
      label: measuringLocations.value.length > 0 ? '지정 측위 초기화' : '지정 측위',
      action: measuringLocations.value.length > 0 ? () => clearMeasuring(state.map) : null,
      children: measuringLocations.value.length > 0 ? null : measuringSub,
    },
  ];
  openMenu(event, menu);
};
//#endregion

//#endregion